import React, { useEffect } from 'react';
import useStyles from '../../../booking-details/OnTripAnnouncement/styles';
import DialogModal from 'views/ui-elements/commons/dialogModal';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { Box, Button, CircularProgress, Grid, MenuItem, Select, TextField } from '@mui/material';
import CustomSelect from 'ui-component/extended/CustomSelect';
import { dispatch } from 'store';
import { useSelector } from 'react-redux';
import Dropdown from 'views/pages/create-quote/dropdown';
import { devConsolelog } from 'helpers/utilityFunctions';
import { addCoupons, getCouponsList, resetAddViewData } from 'store/slices/coupons';

const validationSchema = yup.object().shape({
    couponName: yup.string().required('Coupon Name is required.'),
    description: yup.string().required('Description is required.'),
    category: yup.string().required('Category is required.'),
    comments: yup.string().required('Remarks is required.')
});
const getLoginEmail = (acmData) => {
    const { data = {} } = acmData || {};
    const { acmProfile = {} } = data || {};
    if (acmProfile?.email) return acmProfile?.email;
    return '';
};

const CouponsModalBody = ({ orgCode, setOpenCouponsModal, memberCode }) => {
    const { couponCategoriesData = [], addCouponsData = {} } = useSelector((state) => state.coupons);
    const acmData = useSelector((state) => state.acmDashboard);
    const email = getLoginEmail(acmData);
    // eslint-disable-next-line arrow-body-style
    useEffect(() => {
        return () => {
            dispatch(resetAddViewData());
        };
    }, []);
    const formik = useFormik({
        initialValues: {
            couponName: addCouponsData?.couponName || '',
            description: addCouponsData?.description || '',
            category: '',
            isActive: true,
            organizationCode: orgCode,
            givenBy: email,
            couponCode: addCouponsData?.code || '',
            comments: '',
            memberCode: memberCode || ''
        },
        enableReinitialize: true,
        validationSchema,
        onSubmit: async (values, { resetForm }) => {
            setOpenCouponsModal(false);
            formik.setSubmitting(true);
            try {
                await dispatch(addCoupons({ organizations: [{ ...values }], couponCode: values.couponCode }));
                await dispatch(
                    getCouponsList({
                        orgCode,
                        visibleOnAB: true
                    })
                );
                resetForm();
            } catch (err) {
                setOpenCouponsModal(true);
            }

            formik.setSubmitting(false);
        }
    });

    return (
        <form style={{ marginBottom: '20px', marginTop: '20px' }} onSubmit={formik.handleSubmit}>
            <Box style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={4}>
                        <TextField
                            fullWidth
                            id="couponName"
                            name="couponName"
                            label="Coupon Name"
                            value={formik.values.couponName}
                            onChange={formik.handleChange}
                            error={formik.touched.couponName && Boolean(formik.errors.couponName)}
                            helperText={formik.touched.couponName && formik.errors.couponName}
                            onBlur={formik.handleBlur}
                            disabled
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={4}>
                        <TextField
                            fullWidth
                            id="description"
                            name="description"
                            label="Description"
                            value={formik.values.description}
                            onChange={formik.handleChange}
                            error={formik.touched.description && Boolean(formik.errors.description)}
                            helperText={formik.touched.description && formik.errors.description}
                            onBlur={formik.handleBlur}
                            disabled
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={4}>
                        <Dropdown
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            id="category"
                            name="Category"
                            label="Category"
                            fullWidth
                            value={formik.values.category}
                            dropdownData={couponCategoriesData?.map((i) => ({ label: i?.name, value: i?.id }))}
                            error={formik.touched.category && Boolean(formik.errors.category)}
                            helperText={formik.touched.category && formik.errors.category}
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            id="comments"
                            name="comments"
                            label="Remarks"
                            value={formik.values.comments}
                            onChange={formik.handleChange}
                            error={formik.touched.comments && Boolean(formik.errors.comments)}
                            helperText={formik.touched.comments && formik.errors.comments}
                            onBlur={formik.handleBlur}
                            multiline
                            rows={3}
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Box width="100%" display="flex" justifyContent="center">
                            <Button
                                variant="contained"
                                type="submit"
                                sx={{ width: '240px', padding: '12px 0', marginTop: '30px' }}
                                disabled={formik.isSubmitting}
                            >
                                Save
                            </Button>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        </form>
    );
};

const AddCouponsModal = ({ openCouponsModal = false, setOpenCouponsModal = () => {}, orgCode = '', memberCode = '' }) => {
    const classes = useStyles();

    return (
        <DialogModal
            open={openCouponsModal}
            bodyText={<CouponsModalBody memberCode={memberCode} orgCode={orgCode} setOpenCouponsModal={setOpenCouponsModal} />}
            titleText="Add Coupons"
            titleClass={classes.documentTitle}
            onClose={() => setOpenCouponsModal(false)}
        />
    );
};

export default AddCouponsModal;
